
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "../../common/common-interface";
import { sysLogin } from "@/api/api-basic";
import sha256 from "js-sha256";
import i18n from "@/config/i18n";
import { LANGS } from "@/constants/constants";
@Component
export default class PiLogin extends Vue {
  private test = "light";
  private loading = false;
  private formInline: objAny = {
    userName: "",
    password: "",
    loginType: "0",
    subSystemPkId: "1",
    verCode: "",
    changeLang: ""
  };
  private ruleInline: objAny = {
    userName: [
      {
        required: true,
        message: i18n.t("login.userNamePl"),
        trigger: "blur"
      }
    ],
    password: [
      {
        required: true,
        message: i18n.t("login.passwordPl"),
        trigger: "blur"
      },
      {
        type: "string",
        min: 6,
        message: i18n.t("login.passwordError"),
        trigger: "blur"
      }
    ]
  };
  private changeLangList: objAny[] = [
    {
      value: LANGS.th,
      label: "แบบไทย"
    },
    {
      value: LANGS.en,
      label: "English"
    },
    {
      value: LANGS.zh,
      label: "简体中文"
    }
  ];
  public changeLangFn(val: string): void {
    this.$i18n.locale = val;
    localStorage.setItem("language", val);
    this.ruleInline.userName[0].message = i18n.t("login.userNamePl");
    this.ruleInline.password[0].message = i18n.t("login.passwordPl");
    this.ruleInline.password[1].message = i18n.t("login.passwordError");
    document.title = i18n.t("sysTitle") + "";
  }
  public handleSubmit(): void {
    const eleSub: objAny = this.$refs["formInline"];
    eleSub.validate((valid: objAny) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    const json: objAny = JSON.parse(JSON.stringify(this.formInline));
    json.password = sha256.sha256(json.password);
    this.loading = true;
    const ret = await sysLogin(json);
    if (ret.status == this.$config.apiStatus) {
      this.$common.save("sys_loginData", ret.data[0]);
      this.$router.push("/");
    }
    this.loading = false;
  }
  mounted() {
    // const _self = this;
    document.title = i18n.t("sysTitle") + "";
    document.onkeydown = event => {
      if (event.keyCode === 13 && !this.loading) {
        this.handleSubmit();
        return false;
      }
    };

    if (!localStorage.language) {
      let language = navigator.language;
      if (language == "th") {
        language = "th-TH";
      } else if (language.indexOf("zh") != -1) {
        language = "zh-CN";
      } else {
        language = "en-US";
      }
      this.$i18n.locale = language;
      this.formInline.changeLang = this.$i18n.locale;
      this.changeLangFn(this.$i18n.locale);
    } else {
      this.formInline.changeLang = localStorage.language;
    }
  }
  destroyed() {
    document.onkeydown = null;
  }
}
